import axios from 'axios';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import {
	getCacheRefreshRequest,
	getCacheRefreshSuccess,
	getDashboardServicesRequest,
	getDashboardServicesSuccess,
} from './reducer';
import { TCacheRefreshResponsePayload, TDashboardServicesResponsePayload } from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getCacheRefreshWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TCacheRefreshResponsePayload = yield call(api.dashboard.getCacheRefresh);
		yield put(getCacheRefreshSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getDashboardServicesWorker() {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: TDashboardServicesResponsePayload = yield call(
			api.dashboard.getDashboardServices,
		);
		yield put(getDashboardServicesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			// notificationContainer(String(error), 'error');
		}
	}
}

export function* dashboardSaga() {
	yield takeEvery(getCacheRefreshRequest.type, getCacheRefreshWorker);
	yield takeEvery(getDashboardServicesRequest.type, getDashboardServicesWorker);
}
